import { Component, type ReactNode, type ErrorInfo } from "react";
import type { ThemeObject } from "../../shared/theme.js";

interface PageErrorBoundaryProps {
  children: ReactNode;
  T?: ThemeObject;
  pageName?: string;
}

interface PageErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

// ── FIX #310: ErrorBoundary por página — isola crashes de páginas individuais ──
class PageErrorBoundary extends Component<PageErrorBoundaryProps, PageErrorBoundaryState> {
  constructor(props: PageErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): PageErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[PageErrorBoundary]", error, info);
    const win = window as unknown as Record<string, unknown>;
    if (typeof window !== "undefined" && win.Sentry) {
      (win.Sentry as { captureException: (e: Error, ctx: unknown) => void }).captureException(
        error,
        {
          extra: { componentStack: info?.componentStack, page: this.props.pageName },
        }
      );
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const T = this.props.T || ({} as Partial<ThemeObject>);
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <div style={{ fontSize: 32, marginBottom: 16 }}>⚠️</div>
        <h2
          style={{ color: T.text || "#1E293B", fontSize: 18, fontWeight: 700, margin: "0 0 8px" }}
        >
          Erro ao exibir esta página
        </h2>
        <p style={{ color: T.sub || "#64748B", fontSize: 13, margin: "0 0 6px" }}>
          {String(this.state.error?.message || "Erro desconhecido")}
        </p>
        <button
          onClick={() => {
            this.setState({ hasError: false, error: null });
          }}
          style={{
            marginTop: 16,
            padding: "8px 20px",
            borderRadius: 8,
            border: "none",
            background: "#2563EB",
            color: T.accentText,
            fontWeight: 600,
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          Tentar novamente
        </button>
      </div>
    );
  }
}

export default PageErrorBoundary;
